import "./Hero.css";
import { useState, useEffect } from "react";

const API_URL = process.env.REACT_APP_API_URL || "/api/v1";

function useHeroImages() {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/images/?section=hero`)
      .then((r) => (r.ok ? r.json() : []))
      .then((data) => {
        setImages(data);
        setLoading(false);
      })
      .catch(() => {
        setImages([]);
        setLoading(false);
      });
  }, []);

  return { images, loading };
}

const ArrowRightIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

const STATS = [
  { value: "СРО", label: "проектное и строительное" },
  { value: "С 2009 года", label: "на рынке связи и IT" },
  { value: "УрФО", label: "Екатеринбург и регионы" },
  { value: "24/7", label: "круглосуточная поддержка" },
];

export default function Hero() {
  const { images, loading } = useHeroImages();
  const [current, setCurrent] = useState(0);

  // Слайдер работает только если есть изображения
  useEffect(() => {
    if (images.length <= 1) return;

    const id = setInterval(() => {
      setCurrent((i) => (i + 1) % images.length);
    }, 5000);

    return () => clearInterval(id);
  }, [images.length]);

  const scrollToContact = () => {
    const contactSection = document.getElementById("contact");
    if (contactSection) {
      const headerOffset = 80;
      const elementPosition = contactSection.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  // Показываем фон без картинки, если нет изображений или идёт загрузка
  const hasImages = images.length > 0;

  return (
    <section className="hero">
      {/* Фоновые изображения — только из бэкенда */}
      <div className="hero__bg">
        {!loading && hasImages ? (
          images.map((img, i) => (
            <img
              key={img.id}
              src={`${API_URL}/images/${img.id}/file`}
              alt=""
              className="hero__bg-img"
              style={{
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
                opacity: i === current ? 1 : 0,
                transition: "opacity 1.2s ease-in-out",
                zIndex: i === current ? 1 : 0,
              }}
            />
          ))
        ) : (
          /* Если нет изображений — просто тёмный фон (без картинки) */
          <div
            className="hero__bg-placeholder"
            style={{
              position: "absolute",
              inset: 0,
              backgroundColor: "#0a1a1c",
              zIndex: 0,
            }}
          />
        )}
        <div className="hero__bg-overlay" style={{ zIndex: 2 }} />
      </div>

      {/* Контент */}
      <div className="hero__inner">
        <div className="hero__content">
          <h1 className="hero__title">
            Строительство
            <br />
            сетей связи
            <br />
            <span className="hero__title-accent">и IT-инфраструктуры</span>
          </h1>

          <p className="hero__desc">
            Проектируем, монтируем и настраиваем СКС, СОТ, СКУД, серверные и
            телекоммуникационное оборудование. Строим корпоративные сети для
            промышленных и коммерческих объектов Екатеринбурга и УрФО.
          </p>

          <div className="hero__buttons">
            <button
              onClick={scrollToContact}
              className="hero__btn hero__btn--primary"
            >
              <span>Рассчитать проект</span>
              <ArrowRightIcon />
            </button>
          </div>

          <div className="hero__stats">
            {STATS.map((stat) => (
              <div key={stat.value} className="hero__stat">
                <div className="hero__stat-value">{stat.value}</div>
                <div className="hero__stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="hero__bottom-line" />
    </section>
  );
}